<script>
  import BoxCard from '../BoxCard.svelte'
  import { push } from 'svelte-spa-router'
  import { getURL } from '../../utils'
  import axios from 'axios'
  import { onMount } from 'svelte'
  import { userStore } from '../../store'
  import { User } from '../../roles'
  import ListItem from "../ListItem.svelte";
  import {getUrl, getType, filterExtraApplications} from "./applicationUtil";

  let user = new User()
  let backServiceError = null

  let applicationItems = [
    {
      active: true,
      name: 'Technical Library',
      type: 'external',
      rootUrl: 'https://www.flexlink.com/en/home/support/technical-library',
      icon: 'icon_081_news.png',
      private: false
    },
    {
      active: true,
      name: 'Software Download',
      type: 'same-tab',
      rootUrl: 'https://my.flexlink.com/myflexlink/downloadarea.htm',
      icon: 'icon_downloads.png',
      private: false
    },
    {
      active: true,
      name: 'CAD Files Download',
      type: 'same-tab',
      rootUrl: 'https://my.flexlink.com/myflexlink/cadlibrary.htm',
      icon: 'icon_cad_library.png',
      private: false
    }
  ]

  const extraAppIconMap = new Map([
    ['Robot Config Licenses', 'icon_robotics_2.svg'],
    ['Online Store Tester', 'icon_162_mobilephone.svg'],
    ['Online Store Tester (Prod)', 'icon_162_mobilephone.svg'],
    ['Online Store Tester (CER)', 'icon_162_mobilephone.svg'],
    ['ET Admin', 'icon_200_chat.svg'],
    ['ET Admin (Translate)', 'icon_200_chat.svg'],
    ['Report Tools', 'icon_115_laptop_01.svg'],
    ['List Applicants', 'icon_232_checkbox.svg'],
    ['Group Roles', 'icon_215_people_01.svg'],
    ['Roles', 'icon_005_classroom_01.svg'],
    ['Temp Message Admin', 'icon_254_information.svg'],
    ['People Finder', 'icon_014_human.svg'],
    ['Supplier Archive (FSA)', 'icon_assembly_combining.svg'],
    ['Post Box Admin', 'icon_175_email.svg'],
    ['Post Box', 'icon_175_email.svg'],
    ['Offices', 'icon_264_earth.svg'],
    ['Manage suppliers', 'icon_010_handshake.svg'],
    ['Administration', 'icon_164_printer.svg'],
    ['Lease Manager', 'icon_230_padlockopen.svg'],
    ['Lease manager OLS', 'icon_230_padlockopen.svg'],
    ['Stock availablility', 'icon_004_chart_01.svg'],
    ['Supplier General Data (SGD)', 'icon_239_checklist.svg'],
    ['Online Store', 'icon_266_shopping-chart.png'],
    ['Online Store (During maintenance)', 'icon_266_shopping-chart.png'],
    ['Online Store (SAP/Asia)', 'icon_266_shopping-chart.png'],
    ['Installed Base', 'icon_ib.png'],
    ['Conveyor Condition Monitoring', 'icon_conv_mon.png'],
    ['Spare Part List Generator', 'icon_spare_parts2.png'],
    ['Technical Library', 'icon_081_news.png'],
    ['Software Download', 'icon_downloads.png'],
    ['Download Area', 'icon_downloads.png'],
    ['CAD Files Download', 'icon_cad_library.png'],
    ['CAD Library', 'icon_cad_library.png'],
    ['RFQ', 'icon_gears_special_parts.png'],
    ['Partner Customer', 'icon_215_people_01.svg'],
    ['Partner Users', 'icon_014_human.svg'],
  ]);

  let extraApplications = []
  let boxApplications = []

  onMount(() => {
    getApplications()
  })

  function getApplications () {
    const url = getURL('/private/application/list')
    console.log('[DEBUG] GET', url)
    axios.get(url)
            .then(res => {
              if (res != null && res.data != null && Array.isArray(res.data)) {
                let applications = [...res.data.map(
                        p => ({...p,
                          type: getType(p),
                          icon: extraAppIconMap.get(p.name)})
                ).sort((a, b) => a.orderNo - b.orderNo).filter(app => app.id!== 2103)
                ]
                // console.log('[DEBUG] applications', applications)
                boxApplications = applications
                        .slice(0, 8)
                        .map(a => ({...a, active: true}));

                if(boxApplications.length!==0){
                  applicationItems = boxApplications;
                  extraApplications = filterExtraApplications(boxApplications.map(ba => ba.id), applications)
                }
              }
            })
            .catch(err => {
              backServiceError = err.message
              console.log('[ERROR] getApplications ', err)
            })
  }

  function navigate (event) {
    console.log('[DEBUG] navigate', event.detail)
    const {type, ref} = event.detail
    if (type === 'component') {
      push(ref)
      return
    }
    if (type === 'external') {
      window.open(ref, '_blank')
    }
    if (type === 'same-tab') {
      //window.open(ref)
      window.location.href = ref
    }
  }

  function login () {
    user.login()
  }

  $: appsHeight = $userStore.username && $userStore.username !== '' && applicationItems.length>4 ? '575px' : '200px'

</script>

<div class="w-full bg-gray-100" style={'min-height: ' + appsHeight}>
  <div class="parent flex py-6 items-center justify-between">

    <div class="text-left px-20 my-auto pt-6 pb-12">
      <div class="text-red-500 text-3xl font-light pb-10">
        Apps & Downloads
      </div>
      <div class="font-light text-lg" style="line-height: 1.4em">
        {#if $userStore.username && $userStore.username !== ""}
          <p class="mb-8">
            MyFlexLink offers a variety of applications to simplify and enhance your product and software experience.
            In our <strong>Online Store</strong> you can search for product information,
            order components, configure conveyors
            and keep track of your orders. The <strong>Installed Base</strong> and the
            <strong>Conveyor Condition Monitoring</strong>
            will help to keep an overview of all your systems and upcoming maintenance needs.
          </p>
          <p>
            Whether you are looking for spare parts for a drive unit, ordering information,
            or how to assemble a conveyor, you can find it in the <strong>Technical Library</strong>.
            Under <strong>Software Download</strong>, you will be able to find the FlexLink engineering software suite
            to design your conveyor. Lastly, the <strong>CAD Files Download</strong> offer native files
            for most parts of our components.
          </p>
        {:else}
          <p class="mb-8">
            <span class="text-red-600 cursor-pointer" on:click={login}>Sign In</span> for more applications.
            <span class="block">
                Please be aware that some applications will show a limited result if you are not signed in.
            </span>
          </p>
          <p class="mb-8">
            Don't have a My FlexLink account? <a href="https://my.flexlink.com/myflexlink/registernewuser.htm"
                                                 class="text-red-600 cursor-pointer">Sign Up</a> here.
          </p>
          <p><a href="https://my.flexlink.com/myflexlink/forgotpassword.htm"
                class="text-red-600 cursor-pointer">Forgot your password?</a></p>
        {/if}
      </div>
    </div>

    <div class="flex flex-wrap justify-end items-center flex-shrink-0 md:justify-end boxes">
      {#each applicationItems as app}
        <BoxCard active={app.active} title={app.name} height={260} width={320} ref={getUrl(app)} type={app.type}
                 pic={app.icon}
                 trackingID={'home.' + app.name.replaceAll(' ', '_')}
                 on:navigate={navigate}
        />
      {/each}
    </div>
  </div>

  {#if extraApplications.length!==0}
    <div class="parent flex py-10 bg-white">

      <div class="text-left px-20 my-auto pt-6 pb-12 flex-shrink-0 cards" style="max-width: 640px;">
        <div class="text-red-500 text-3xl font-light self-center">
          More applications
        </div>
      </div>

      <div class="w-full flex-grow bg-gray-100 apps">
        <div class="grid grid-cols-2 gap-3 px-36 py-12 list">
          {#each extraApplications as app}
            <ListItem active={app.active} title={app.name} height={25} width={100}
                      ref={getUrl(app)}
                      type={app.type}
                      pic={app.icon}
                      trackingID={'home.' + app.name.replaceAll(' ', '_')}
                      on:navigate={navigate}
            />
          {/each}
        </div>
      </div>

    </div>
  {/if}

</div>

<style>
  @media (max-width: 1439px) {
    .parent {
      flex-wrap: wrap;
    }

    .boxes {
      width: 100%;
      justify-content: center;
    }

    .list {
      grid-template-columns: repeat(1, minmax(0, 1fr));
      padding-left: 3rem;
      padding-right: 3rem;
    }

    .cards{
      width: 640px;
    }

    .apps{
      margin-left: 3rem;
      margin-right: 3rem;
      align-self: center;
    }
  }

    /*@media (min-width: 1280px) {*/
    /*    .boxes {*/
    /*        width: 640px;*/
    /*        justify-content: left;*/
    /*    }*/
    /*}*/
    @media (min-width: 1440px) {
      .boxes {
        max-width: 960px;
        justify-content: left;
      }

      .list {
        grid-template-columns: repeat(2, minmax(0, 1fr));
        padding-left: 9rem;
        padding-right: 9rem;
      }

      .cards{
        width: 640px;
      }

      .apps{
        margin-left: 0;
        margin-right: 8rem;
        align-self: end;
      }
    }

    @media (min-width: 1800px) {
      .boxes {
        max-width: 1280px;
        justify-content: left;
      }

      .cards{
        width: 640px;
      }
    }
</style>